/**
 * The live "yozmoqda" state, one entry per conversation. Filled by two sources: the socket's
 * `conversation.typing` frames, and a refused send (409) that names the person writing.
 */
import { create } from "zustand";

import type { TypingEntry } from "./presenceModel";

interface PresenceState {
  typing: Readonly<Record<string, TypingEntry>>;
  markTyping: (conversationId: number, entry: TypingEntry) => void;
}

function recordTyping(conversationId: number, entry: TypingEntry): (state: PresenceState) => Partial<PresenceState> {
  return (state) => ({ typing: { ...state.typing, [String(conversationId)]: entry } });
}

export const usePresence = create<PresenceState>((set) => ({
  typing: {},
  markTyping: (conversationId: number, entry: TypingEntry): void => {
    set(recordTyping(conversationId, entry));
  },
}));
